import { CopyLinkField } from '@/components/ui/clipboard/CopyLinkField';
import { toaster } from '@/components/ui/toaster';
import { Button, Stack, Text } from '@chakra-ui/react';
import { OpenNewWindow } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import {
  ASSISTANT_PROVIDERS,
  CHATGPT_ADD_APP_URL,
  CHATGPT_DEVELOPER_MODE_URL,
  mcpServerUrl,
} from './assistant-providers';
import { AssistantConnectStep } from './AssistantConnectStep';

/**
 * ChatGPT has no prefilled link, so the click that opens it also copies the address:
 * the brand lands where the app is created with the address ready to paste.
 */
export const ChatGptConnectSteps: React.FC = () => {
  const { t } = useTranslation();
  const { name } = ASSISTANT_PROVIDERS.chatgpt;
  const address = mcpServerUrl();

  const copyAddress = () => {
    navigator.clipboard
      ?.writeText(address)
      .then(() =>
        toaster.create({
          type: 'success',
          description: t('integrations.assistants.chatgpt.copied'),
        })
      )
      .catch(() => undefined);
  };

  return (
    <Stack gap={5}>
      <AssistantConnectStep
        index={1}
        title={t('integrations.assistants.chatgpt.developerModeStep')}
      >
        <Button asChild variant="outline" size="sm" alignSelf="flex-start">
          <a href={CHATGPT_DEVELOPER_MODE_URL} target="_blank" rel="noopener noreferrer">
            {t('integrations.assistants.chatgpt.openSettings')}
            <OpenNewWindow width={14} height={14} />
          </a>
        </Button>
      </AssistantConnectStep>
      <AssistantConnectStep index={2} title={t('integrations.assistants.chatgpt.addStep')}>
        <Button asChild size="sm" alignSelf="flex-start">
          <a
            href={CHATGPT_ADD_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={copyAddress}
          >
            {t('integrations.assistants.chatgpt.copyAndOpen')}
            <OpenNewWindow width={14} height={14} />
          </a>
        </Button>
        <CopyLinkField value={address} copyLabel={t('common.copy')} />
      </AssistantConnectStep>
      <AssistantConnectStep
        index={3}
        title={t('integrations.assistants.dialog.signInStep', { name })}
      />
      <Text fontSize="xs" color="fg.muted">
        {t('integrations.assistants.chatgpt.planNote')}
      </Text>
    </Stack>
  );
};
